(function($) {

	'use strict';

	var init = function() {
        $('.association__more__btn').on('click', openMoreAssociations);
	};

	var openMoreAssociations = function(){
        $('.association__more__list').slideDown(300);
        $('.association__more__btn').fadeOut(100).slideUp(300);
    }

	$(document).ready(function(){
        init();
	});

})(jQuery);
